/*
 * @Author: fanyang 1050549505@qq.com
 * @Date: 2021-09-30 11:21:23
 * @LastEditors: fanyang 1050549505@qq.com
 * @LastEditTime: 2022-07-22 09:50:42
 * @FilePath: /yhkh/src/api/dataApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { postAxiosByJson, postAxios, getAxios, getAxiosJsonByData } from '../axios/http';
import qs from 'qs'
export const datasApi = {

    //登录
    Login: (data) => {
        return postAxiosByJson('/login', JSON.stringify(data))
    },
    //sso登录
    sso: () => {
        return getAxios('/sso')
    },
    //sso登录退出
    ssoLogOut: () => {
        return postAxiosByJson('/sso/logOut')
    },
    // 获取异常与报警提醒数据
    getAbnormalData: (data) => {
        return getAxios('/getAbnormal', data)
    },
    //获取报警通知
    getAlarmData: (data) => {
        return getAxios('/getAlarm', data)
    },
    //获取人员列表
    getMemberListData: (data) => {
        return getAxios('/getMemberList', data)
    },
    //获取会员详情数据
    getMemberDetailData: (data) => {
        return getAxios('/getMemberData', data)
    },
    //根据安装地址查询数据
    getHabitDataByAddr: (data) => {
        return getAxios('/getHabitData', data)
    },
    //获取设备在线数目
    getDeviceNumData: (data) => {
        return getAxios('/getDeviceNum', data)
    },
    //获取生活习惯数据
    getLifeHabitData: (data) => {
        return postAxios('/getLifeHabitData', data)
    },
    //获取老人异常提醒数据
    getMemberAbnomarlData: (data) => {
        return getAxios('/getMemberAbnomarlData', data)
    },
    //获取老人报警通知
    getMemberNotifData: (data) => {
        return getAxios('/getMemberNotifData', data)
    },
    //获取老人健康数据
    getMemberHealthData: (data) => {
        return getAxios('/getMemberHealthData', data)
    },
    //获取老人呼救对讲url
    getTalkSosUrl: (data) => {
        return postAxios('/getTalkSosUrl', data)
    },
    //获取水表数据
    //获取生活习惯数据
    getLifeHabitWaterData: (data) => {
        return postAxios('/getLifeHabitWaterData', data)
    },
    //获取报警统计数据
    getAlarmTotalData: (data) => {
        return getAxios('/getAlarmTotal', data)
    },
    //获取设备统计数据
    getDevicesNumData: (data) => {
        return getAxios('getDevicesNum', data)
    },
    //设置老人备注
    updateMemberRemark: (data) => {
        return postAxios('/update/remark', data)
    },
    //设置报警处理结果
    updateAlarmResult: (data) => {
        return postAxios('/update/alarmResult', data)
    },
    //查询老人详情信息
    getOlderDetialInfo: (data) => {
        return postAxios('/older/detail', data)
    }

}

